import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=1e0c16e8&"
import script from "./WelcomeModal.vue?vue&type=script&lang=ts&"
export * from "./WelcomeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports